import { DeliveryMethodTranslationService } from '../../../shared/translations/delivery-methods-translations.service';
import { DateObject } from '../reusables/date-object';
import { Currency } from '../reusables/currency';

/**
 * Process configuration class that is part of the lottery
 */
export class ProcessConfiguration {
  public '@id': string;
  public id: number;
  public optionalNonContiguousSeating: boolean;
  public orderRequestRequired: boolean;
  public secondaryTicketRequestAvailable: boolean;
  public possiblePriceDeviation: string;
  public ticketPersonalizationEnabled: boolean;
  public submissionsWithdrawableByOwner: boolean;
  public showPrices: boolean;
  public specialRequirement: boolean;
  public submissionCollectionTiming: SubmissionCollectionTiming;
  public priceCategories: any;
  public delivery: Delivery;

  constructor(processConfiguration: any, private t: DeliveryMethodTranslationService) {
    this.id = processConfiguration.id;
    this['@id'] = processConfiguration['@id'];
    this.optionalNonContiguousSeating = processConfiguration.optionalNonContiguousSeating;
    this.orderRequestRequired = processConfiguration.orderRequestRequired;
    this.secondaryTicketRequestAvailable = processConfiguration.secondaryTicketRequestAvailable;
    this.possiblePriceDeviation = processConfiguration.possiblePriceDeviation;
    this.ticketPersonalizationEnabled = processConfiguration.ticketPersonalizationEnabled;
    this.submissionsWithdrawableByOwner = processConfiguration.submissionsWithdrawableByOwner;
    this.showPrices = processConfiguration.showPrices;
    this.specialRequirement = processConfiguration.specialRequirement;
    this.submissionCollectionTiming = new SubmissionCollectionTiming(processConfiguration.submissionCollectionTiming);
    this.priceCategories = processConfiguration.priceCategories;
    this.delivery = new Delivery(processConfiguration.delivery, this.t);
  }
}

/**
 * Class for all the available delivery methods that are part of the process configuration
 */
export class Delivery {
  public deliveryFee: Currency;
  public deliveryMethod: string;

  public deliveryMethods: Array<any> = [
    { value: 'print_at_home', status: this.t.i18nPrintHome },
    { value: 'post_shipping', status: this.t.i18nMailing },
    { value: 'digital_ticket', status: this.t.i18nDigitalTicket },
  ];

  constructor(delivery: any, private t: DeliveryMethodTranslationService) {
    this.deliveryFee = new Currency(parseFloat((delivery.deliveryFee / 100).toString()).toFixed(2), 'EUR');
    this.deliveryMethod = delivery.deliveryMethod;
  }

  public get translatedDelivery(): string {
    const delivery = this.deliveryMethods.find(type => this.deliveryMethod === type.value);
    return delivery ? delivery.status : this.deliveryMethod;
  }
}

/**
 * Class for all the submission collection timing that are part of the process configuration
 */
export class SubmissionCollectionTiming {
  public start: DateObject;
  public deadline: DateObject;

  constructor(submissionCollectionTiming: any) {
    this.start = submissionCollectionTiming.start ? new DateObject(submissionCollectionTiming.start, 'dd.MM.yyyy HH:mm') : null;
    this.deadline = submissionCollectionTiming.deadline ? new DateObject(submissionCollectionTiming.deadline, 'dd.MM.yyyy HH:mm') : null;
  }
}
